__turbopack_context__.v({
  "clamped": "style-module-scss-module__nFYQaq__clamped",
  "content": "style-module-scss-module__nFYQaq__content",
  "toggle": "style-module-scss-module__nFYQaq__toggle",
  "toggleInline": "style-module-scss-module__nFYQaq__toggleInline",
  "wrapper": "style-module-scss-module__nFYQaq__wrapper",
});
